import { cn } from '@/lib/utils';

interface Props {
  onClick: () => void;
  className?: string;
  title: React.ReactNode;
  subtitle: React.ReactNode;
}

export function ButtonEmpty({ title, subtitle, onClick, className }: Props) {
  return (
    <button
      onClick={onClick}
      className={cn(
        'hover:bg-muted/40 flex h-32 w-full flex-col items-center justify-center gap-1 rounded-md border border-dashed p-3 transition-colors hover:cursor-pointer',
        className
      )}
    >
      <div className='text-muted-foreground text-sm'>{title}</div>
      <div className='text-muted-foreground text-xs'>{subtitle}</div>
    </button>
  );
}
